import { IApiError, TApiErrorCallback } from "../api.interfaces";
import { IAuthFailureHandlerApi, IPerTypeStrategy, TNeedsLoginAndCall } from "./interfaces";
import { DefaultReAuthStrategy } from "./reAuthStrategy";
import { ExpiredPasswordStrategy } from "./expiredPasswordStrategy";
import { InvalidPermissionsStrategy } from "./invalidPermissionsStrategy";
import { FallBackStrategy } from "./fallBackStrategy";

/** Dispatches to the matching handler via a switch on error.data.type. */
export class AuthFailureStrategyBuilder {
    constructor(private readonly api: IAuthFailureHandlerApi) {}

    build(
        error: IApiError,
        method: string
    ) {
        const strategy = this.findStrategy(this.api, error, method);

        return (errorCallback: TApiErrorCallback | undefined, needsLoginAndCall: TNeedsLoginAndCall) => strategy.handle(error, errorCallback, needsLoginAndCall);
    }

    private findStrategy(api: IAuthFailureHandlerApi, error: IApiError, method: string): IPerTypeStrategy {
        const notAuthenticate = method !== "Authenticate";
        switch (error.data?.type) {
            case "InvalidUserException":
            case "InvalidMyAdminUserException":
            case "InvalidCredentialsError":
                return notAuthenticate ? new DefaultReAuthStrategy(api) : new FallBackStrategy();
            case "ArgumentException":
                return notAuthenticate && error.message?.includes("The Credentials object is missing or empty") ? new DefaultReAuthStrategy(api) : new FallBackStrategy();
            case "ExpiredPasswordException":
                return new ExpiredPasswordStrategy(api);
            case "InvalidPermissionsException": {
                const iamMessages = ["User is not an IAM user.", "User has not been validated via IAM."];
                return iamMessages.some(m => error.message?.includes(m)) ? new InvalidPermissionsStrategy(api) : new FallBackStrategy();
            }
            default:
                return new FallBackStrategy();
        }
    }
}
